import { useCallback, useEffect, useState } from 'react';
import { SELECTED_AUDIO_OUTPUT_KEY } from 'screens/TelehealthScreen/utils/constants';
import { useDevices } from 'screens/TelehealthScreen/hooks';

import { saveTelehealthLog } from '../../utils/helpers';

// Active sink is a property used for the audio component to know the current audio output device
// This hook is used to handle with the active sink and prevent, for example, the issue when the user
// unplugs a headphone and the audio do not change to the speaker
// When the user change the output device it also to updates the active sink
export default function useActiveSinkId() {
  const { audioOutputDevices } = useDevices();
  const [activeSinkId, setActiveSinkId] = useState('default');

  const updateActiveSinkId = useCallback(
    (sinkId: string) => {
      window.localStorage.setItem(SELECTED_AUDIO_OUTPUT_KEY, sinkId);

      setActiveSinkId(sinkId);
      saveTelehealthLog('Patient/Guest - Changing audio output device', { key: SELECTED_AUDIO_OUTPUT_KEY, sinkId });
    },
    [setActiveSinkId],
  );

  // persists a pre-selected output device if it is still valid
  useEffect(() => {
    const selectedSinkId = window.localStorage.getItem(SELECTED_AUDIO_OUTPUT_KEY);
    const hasSelectedAudioOutputDevice = audioOutputDevices.some(
      (device: MediaDeviceInfo) => selectedSinkId && device.deviceId === selectedSinkId,
    );

    if (hasSelectedAudioOutputDevice) {
      setActiveSinkId(selectedSinkId!);
    }
  }, [audioOutputDevices]);

  return [activeSinkId, updateActiveSinkId] as const;
}
